module.exports = __webpack_public_path__ + "img/Truck-reversing-2-1000-COMPRESSED-CROPPED.ae17aaf7.gif";